import { action, computed, makeObservable, observable } from 'mobx';

import { IRootStore } from 'shared/entities/store/rootStore';
import { IBaseManagersStore } from 'shared/entities/store/managersStore';
import { ComponentLoadingStore } from 'stores/componentLoadingStore';
import NewListModel from 'shared/models/NewListModel';
import { LoadingStageModel } from 'shared/models/loadingStage';

export default abstract class BaseManagersStore<T>
  extends ComponentLoadingStore
  implements IBaseManagersStore<T>
{
  readonly managers: NewListModel<T> = new NewListModel<T>();

  readonly rootStore: IRootStore;

  selectedManagerId: string | null = null;

  readonly addingManagerStage: LoadingStageModel = new LoadingStageModel();

  constructor({ rootStore }: { rootStore: IRootStore }) {
    super();
    this.rootStore = rootStore;

    makeObservable(this, {
      selectedManagerId: observable,
      rootStore: observable,

      selectedManager: computed,

      changeSelectedManagerId: action,
      unselectSelectedManager: action
    });
  }

  get loaded(): boolean {
    return this.managers.loadingStage.successfullyLoaded;
  }

  abstract get canBeLoaded(): boolean;

  changeSelectedManagerId = (id: string | null) => {
    this.selectedManagerId = id;
  };

  unselectSelectedManager = () => {
    this.changeSelectedManagerId(null);
  };

  get selectedManager(): T | null {
    return this.selectedManagerId
      ? this.managers.getEntity(this.selectedManagerId)
      : null;
  }

  abstract load(): Promise<BaseResponse>;

  remove({ id }: { id: string }): void {
    if (this.selectedManagerId === id) {
      this.unselectSelectedManager();
    }
    this.managers.removeEntity(id);
  }

  reset(): void {
    this.managers.reset();
  }
}
